
<div class="outer-container">
  <div class="top">

    <div class="filter-container">
      <div>
        <span>Genre: </span>
        <select class="filter-select" id="genre" title="genre" [(ngModel)]="selectedGenre" (change)="setAllCreatorsByGenre()">
          <option *ngFor="let g of genreType" [value]="g.value">{{ g.label }}</option>
        </select>
      </div>
      <div>
        <span>Partner Tag: </span>
        <select class="filter-select" id="partnerTags" title="Partner Tags" [(ngModel)]="selectedPartnerTagFilter" (change)="updateFilteredCreators()">
          <option *ngFor="let pt of sortedTags" [value]="pt[0]">{{ pt[0] }} <span *ngIf="pt[1] !== 0">({{ pt[1] }})</span></option>
        </select>
      </div>
      <div>
        <span>Status: </span>
        <select class="filter-status" id="status" title="Status" [(ngModel)]="selectedStatusFilter" (change)="updateFilteredCreators()">
          <option *ngFor="let status of researchCreatorStatusFilter" [value]="status.value">{{ status.label }}</option>
        </select>
      </div>
    </div>


    <div class="chart-tag-container">
      <div *ngIf="chartData.length > 0">
        <app-chart [data]="chartData" [labels]="chartLabels" [options]="chartOptions" (chartClickNotify)="handleChartClickNotify($event)"></app-chart>
      </div>
      <div class="partner-tag-table-container" *ngIf="filteredPartnerTags.length > 0">
        <div class="videos-table">
          <div class="partner-tag-table-header">
            <span>Partner Tags ({{filteredPartnerTags.length}})</span>
            <span><img (click)="downloadPartnerTags()" class="clickable" alt="download icon" src="download_icon.svg"></span>
          </div>
          <div class="header">Video</div>
          <div class="header">Handle</div>
          <div class="header">Partner Tag</div>
          <div class="header">Post Date</div>
          <div class="header">Views</div>
          <ng-container *ngFor="let pt of filteredPartnerTags">
            <div class="cell" [ngClass]="{'yellow': pt.handle === selectedHandle}"><a target="_blank" [href]="getVideoLink(pt.handle!, pt.videoId)">Link</a></div>
            <div class="cell clickable" [ngClass]="{'yellow': pt.handle === selectedHandle}" (click)="setSelectedHandle(pt.handle!)">{{pt.handle}}</div>
            <div class="cell clickable" [ngClass]="{'yellow': pt.handle === selectedHandle}" (click)="setSelectedHashtag(pt.tag)">{{pt.tag.substring(0,20)}}</div>
            <div class="cell" [ngClass]="{'yellow': pt.handle === selectedHandle}">{{pt.postDate | date:'MM/dd/yy hh:mm a'}}</div>
            <div class="cell right" [ngClass]="{'yellow': pt.handle === selectedHandle}">{{pt.viewCount | kmb}}</div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>


  <div class="bottom">
    <div class="creator-table" *ngIf="filteredCreators.length > 0">
      <div class="partner-tag-table-header">
        <span>Creators ({{filteredCreators.length}})</span>
        <span><img (click)="downloadCreators()" class="clickable" alt="download icon" src="download_icon.svg"></span>
        <span class="clear-link clickable" (click)="clearSelection()">Clear</span>
        <span class="clear-link clickable" (click)="openAddCreatorDialog()">Add</span>
      </div>

      <!-- Filter Row -->
      <div class="header"><input id="handleFilter" type="text" [(ngModel)]="handleFilter" (input)="applyTextFilters()" placeholder="Handle Filter"></div>
      <div class="header"></div>
      <div class="header"></div>
      <div class="header"></div>
      <div class="header"></div>
      <div class="header"></div>
      <div class="header"></div>
      <div class="header"><input id="emailFilter" type="text" [(ngModel)]="emailFilter" (input)="applyTextFilters()" placeholder="Email Filter"></div>
      <div class="header"></div>
      <div class="header"></div>
      <!-- End Filter Row -->

      <div class="header">Handle</div>
      <div class="header">Partners</div>
      <div class="header">Genre</div>
      <div class="header">Status</div>
      <div class="header">Followers</div>
      <div class="header"></div>
      <div class="header"></div>
      <div class="header">Latest Email in Bio</div>
      <div class="header">Scraped</div>
      <div class="header">Views/Video</div>
      <ng-container *ngFor="let creator of filteredCreators; index as i;">
        <div [ngClass]="{'yellow': creator.tiktok === selectedHandle}" (click)="filterPartnerTags(creator)" class="cell">{{creator.tiktok}}</div>
        <div [ngClass]="{'yellow': creator.tiktok === selectedHandle}" class="cell right">{{creator.partnerTags.length}}</div>
        <div [ngClass]="{'yellow': creator.tiktok === selectedHandle}" class="cell">
          <select title="genre" [(ngModel)]="creator.genre" (change)="updateGenre(creator)">
            <option *ngFor="let genre of genreType" [value]="genre.value">{{ genre.label }}</option>
          </select>
        </div>
        <div [ngClass]="{'yellow': creator.tiktok === selectedHandle}" class="cell">
          <select title="status" [(ngModel)]="creator.status" (change)="updateStatus(creator)"
            [ngStyle]="{'backgroundColor': getBackgroundColor(creator.status)}">
            <option *ngFor="let status of researchCreatorStatus" [value]="status.value">{{ status.label }}</option>
          </select>
        </div>
        <div [ngClass]="{'yellow': creator.tiktok === selectedHandle}" class="cell centered">{{creator.tiktokFollowers | kmb}}</div>
        <div [ngClass]="{'yellow': creator.tiktok === selectedHandle}" class="cell"><a rel="noopener" (click)="tiktokClick(creator)" href="https://tiktok.com/{{creator.tiktok}}" target="_blank"><img class="icon" alt="tiktok icon" src="tiktok_icon.svg"></a></div>
        <div [ngClass]="{'yellow': creator.tiktok === selectedHandle}" class="cell"><img class="icon" (click)="deleteCreator(creator)" alt="delete icon" src="delete_icon.svg"></div>
        <div [ngClass]="{'yellow': creator.tiktok === selectedHandle}" class="cell">
          <ng-container *ngIf="creator.emailInBioChange && creator.emailInBioChange.length; else noEmail">
            <div *ngFor="let emailObj of creator.emailInBioChange.slice(-1)" class="email-entry">
              <span class="email-left">{{emailObj.newEmail}}</span>
              <span class="email-date">{{emailObj.changeDate}}</span>
            </div>
          </ng-container>
          <ng-template #noEmail>-</ng-template>
        </div>
        <div [ngClass]="{'yellow': creator.tiktok === selectedHandle}" class="cell right">{{creator.videosScraped}}</div>
        <div [ngClass]="{'yellow': creator.tiktok === selectedHandle}" class="cell centered">{{creator.avgVideoViewCount | kmb}}</div>
      </ng-container>
    </div>
  </div>

<app-dialog [(visible)]="showAddCreatorDialog">
  <div class="form-header">Add Creator</div>
  <div>
    <div class="form-item">
      <span>TikTok Handle</span>
      <span><input [(ngModel)]="newCreatorTiktok" placeholder="@handle"></span>
    </div>
    <div class="form-item">
      <span>Genre</span>
      <span>
        <select [(ngModel)]="newCreatorGenre" title="genre">
          <option *ngFor="let g of genreType" [value]="g.value">{{ g.label }}</option>
        </select>
      </span>
    </div>
  </div>
  <div class="center-text">
    <button (click)="addCreatorClick()">Add Creator</button>
  </div>
</app-dialog>
</div>

